module.exports = __webpack_public_path__ + "static/media/coal.00ef0f91.jpg";